import React, { useContext, useEffect, useState } from "react";
import { CheckCircleFilled, WarningFilled } from "@ant-design/icons";
import Voice from "../../assets/voice/alarm.mp3";
import "./Alert.css";
import SmartoptLogo1 from "../../assets/image/smartoptLogo1.png";
import { baseUrl } from "../../config";
import TableContext from "../../Context/TablePosition";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

/**
 * Sıradaki sipariş alanı — etiket üstte / değer altta (uygulama genelindeki
 * `CardItem` deseniyle aynı dil, yalnız operatör ekranına göre çok büyütülmüş).
 * Bu blok yalnız alarm durumunda görünür; arkaplan turuncu ya da tema yüzeyi
 * olabildiği için panel yarı saydam beyazla (`white/10`) çiziliyor, metin ise
 * kapsayıcının o an belirlediği rengi (beyaz ya da tema rengi) miras alıyor.
 */
const OrderField = ({ label, value }) => (
  <div className="flex min-w-0 flex-1 flex-col gap-2 rounded-2xl border border-white/20 bg-white/10 px-8 py-6">
    <span className="text-[26px] font-bold uppercase tracking-[0.08em] opacity-70 largeDesktop:text-[32px]">
      {label}
    </span>
    <span className="truncate text-[56px] font-extrabold leading-tight largeDesktop:text-[72px]">
      {value || "—"}
    </span>
  </div>
);


const Alert = () => {
  const [second, setSecond] = useState(59);
  const [alarm, setAlarm] = useState(false);
  const [nextProduction, setNextProduction] = useState({
    orderNo: "",
    siparis: "",
    target: null,
  });
  const [socket, setSocket] = useState(null);
  const { setCurrentUrl } = useContext(TableContext)
  const location = useLocation();
  const { t } = useTranslation();


  useEffect(() => {
    localStorage.setItem("urlpaintshop", location.pathname)
    setCurrentUrl(localStorage.getItem("urlpaintshop"));
  }, [location.pathname, setCurrentUrl])


  useEffect(() => {
    const handleOnline = () => {
      console.log("Yeniden Bağlanıyor...");
      const ws = new WebSocket(`${baseUrl}/ws/hang-socket-server/`);
      setSocket(ws);
    };

    const handleOffline = () => {
      console.log("Çevrimdışı - WebSocket bağlantısı kapatıldı.");
      if (socket) {
        socket.close();
      }

    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);

    };
  }, [socket]);

  useEffect(() => {
    const ws = new WebSocket(
      `${baseUrl}/ws/hang-socket-server/`
    );
    setSocket(ws);

    return () => {
      ws.close();
    };
  }, []);


  useEffect(() => {
    let time;

    time = setInterval(() => {
      setSecond(second - 1);
    }, 1000);

    if (second === -1) {
      setSecond(59);
    }

    return () => clearInterval(time);
  }, [second]);

  useEffect(() => {
    let timer;

    if (socket) {
      socket.onmessage = function (e) {
        let data = JSON.parse(e.data);
        setAlarm(data?.type?.info_type || data?.info_type || data?.type);
        setNextProduction({
          orderNo: data?.type?.next_order_nr,
          siparis: data?.type?.next_siparis,
          target: data?.type?.next_target,
        });
      };
    }
    timer = setInterval(() => {
      if (socket.readyState === WebSocket.OPEN) {
        console.log("send HealthCheck");
        socket.send(
          JSON.stringify({
            event_type: "HealthCheck",
          })
        );
      } else if (socket.readyState === WebSocket.CLOSED) {
        console.log("Socket is closed. Reopening...");
        const newSocket = new WebSocket(`${baseUrl}/ws/hang-socket-server/`);
        setSocket(newSocket);
      }
    }, 8000);
    return () => clearInterval(timer);
  }, [alarm, socket]);

  const isAlarm = alarm === "Alarm";
  const blinkOrange = isAlarm && second % 2 !== 0;

  return (
    <div
      className="flex w-full h-full justify-center items-center relative"
      style={
        isAlarm
          ? blinkOrange
            ? { backgroundColor: "rgba(255,104,64)" }
            : { backgroundColor: "rgb(var(--surface))" }
          : null
      }
    >
      <img
        className="absolute right-6 top-6 w-[160px] opacity-90"
        src={SmartoptLogo1}
        alt="Smartopt Logo"
      />

      <div
        className="cardContainer"
        style={
          isAlarm
            ? blinkOrange
              ? { backgroundColor: "rgba(255,104,64)", color: "#fff" }
              : { backgroundColor: "rgb(var(--surface))" }
            : { color: "#0d111a" }
        }
      >
        {isAlarm ? (
          <div className="flex w-full flex-col items-center gap-10 px-10 py-10">
            <audio src={Voice} autoPlay="Autoplay" loop />

            <div className="flex items-center gap-4">
              <WarningFilled className="text-[60px]" />
              <h1 className="text-[64px] font-extrabold tracking-tight largeDesktop:text-[84px]">
                {t("alert.nextOrder")}
              </h1>
            </div>

            <div className="flex w-full max-w-6xl flex-col gap-6 tablet:flex-row">
              <OrderField label={t("alert.orderNo")} value={nextProduction.orderNo} />
              <OrderField label={t("alert.orderName")} value={nextProduction.siparis} />
              <OrderField label={t("alert.orderQuantity")} value={nextProduction.target} />
            </div>
          </div>
        ) : (
          <div className="flex flex-col items-center gap-6 px-10 text-center">
            <CheckCircleFilled className="text-[80px] text-state-ok" />
            <div className="text-[64px] font-extrabold leading-tight largeDesktop:text-[84px]">
              {t("alert.currentOrderInProgress")}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Alert;
